import { IAges } from "app/UtilitiesAndConstants/types/age";
import { SELECT_ALL } from "app/UtilitiesAndConstants/Constants/multiSelect";

export const AVAILABLE_AGES: IAges = [
    { id: "18to24", text: "18-24", api: "18" },
    { id: "25to34", text: "25-34", api: "25" },
    { id: "35to44", text: "35-44", api: "35" },
    { id: "45to54", text: "45-54", api: "45" },
    { id: "55to64", text: "55-64", api: "55" },
    { id: "65plus", text: "65+", api: "65" },
];

export const SELECT_ALL_AGES = SELECT_ALL;
